export default "__VITE_ASSET__BFDKuc8j__"